import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type FrequencyFile = {
  frequency_file_id?: number; // 프리퀀시 파일 idx
  frequency_id?: number; // 프리퀀시 idx
  file_name?: string; // 파일명
  file_url?: string; // 파일 URL
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] FrequencyFile
   * --
   */
  getFrequencyFiles: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_FREQUENCY_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] FrequencyFile
   * --
   */
  getFrequencyFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_FREQUENCY_FILE, {
        frequency_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] FrequencyFile
   * --
   */
  createFrequencyFile: async (body: FrequencyFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_FREQUENCY_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] FrequencyFile
   * --
   */
  updateFrequencyFile: async (body: FrequencyFile) => {
    try {
      const { frequency_file_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_FREQUENCY_FILE, {
        frequency_file_id: frequency_file_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] FrequencyFile
   * --
   */
  deleteFrequencyFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_FREQUENCY_FILE, {
        frequency_file_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
